<template>
  <b-card header="Ranking de Comissoes" class="mb-3">
    <StateRenderer
      :loading="report.loading"
      :error="report.error"
      :data="summary"
    >
      <b-alert
        v-if="summary.length === 0"
        show
        variant="secondary"
        class="text-center"
      >
        Nenhuma comissao registrada no periodo selecionado
      </b-alert>
      <template v-else>
        <b-table
          :fields="fields"
          :items="rankingItems"
          striped
          hover
          small
          responsive
        >
          <template #cell(position)="{ index }">
            <b-badge variant="primary">{{ index + 1 }}</b-badge>
          </template>
          <template #cell(userName)="{ item }">
            <span class="font-weight-bold">{{ item.userName }}</span>
          </template>
          <template #cell(totalPoints)="{ item }">
            <span>{{ item.totalPoints }}</span>
          </template>
        </b-table>
      </template>
    </StateRenderer>
  </b-card>
</template>

<script>
import StateRenderer from '@/components/StateRenderer'

export default {
  name: 'CommissionsRanking',
  components: { StateRenderer },
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields() {
      return [
        { key: 'position', label: '#' },
        { key: 'userName', label: 'Funcionario' },
        { key: 'totalPoints', label: 'Total de Vendas' }
      ]
    },
    summary() {
      const data = this.report?.data || {}
      if (Array.isArray(data.summary)) return data.summary
      if (Array.isArray(data)) return data
      return []
    },
    rankingItems() {
      return [...this.summary]
        .sort((a, b) => (b.totalPoints || 0) - (a.totalPoints || 0))
        .map((item, index) => ({
          ...item,
          position: index + 1
        }))
    }
  }
}
</script>
